import { render, staticRenderFns } from "./RestBreaks.vue?vue&type=template&id=6aa5618c&"
import script from "./RestBreaks.vue?vue&type=script&lang=js&"
export * from "./RestBreaks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports